module.exports = __webpack_public_path__ + "media/images/countrysquared/ai-c11b3de27568a802fa2ff2ef1845a395.svg";